import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import appReducer from '../reducers/appReducer';
import trackJSLogger from './Middleware/trackJSLogger';

const store = createStore(
  appReducer,
  undefined,
  composeWithDevTools({trace: true, traceLimit: 25})(
    applyMiddleware(thunk, trackJSLogger),
  ),
);

export default store;
